export default "__VITE_ASSET__CUW$kSHz__"